import { inject, Injectable } from '@angular/core';
import { AuthService } from '@brightside/core/auth';
import { environment, Environment } from '@brighthub/environment';

export const TAB_VIEW_GROUPS = {
  'care-plan': 'BSB_Careplan_View',
  finances: 'BSB_Financial_View',
  profile: 'BSB_Profile_View',
} as const;
export type ProtectedTab = keyof typeof TAB_VIEW_GROUPS;

/** Tab visibility only: edit permissions and feature flags are independent. */
export function canViewTab(
  deployment: Environment['environment'],
  tab: ProtectedTab,
  hasGroup: (group: string) => boolean,
): boolean {
  if (deployment === 'dev' || deployment === 'stage') return true;
  return (
    hasGroup(TAB_VIEW_GROUPS[tab]) ||
    (deployment === 'uat' && hasGroup('internal_service_admin'))
  );
}

@Injectable({ providedIn: 'root' })
export class TabViewAccess {
  private readonly auth = inject(AuthService);
  canView(tab: ProtectedTab): boolean {
    return canViewTab(environment.environment, tab, (group) =>
      this.auth.isInGroup(group),
    );
  }
}
